
export const IDS = {
    // states:
    app_policies: 'app.policies',
    app_policies_dashboard: 'app.policies.dashboard',
    app_policies_settings: 'app.policies.settings',
    app_policies_documents: 'app.policies.documents',
};
